// extracted by mini-css-extract-plugin
module.exports = {"container":"WishesFilter_container__MHAYs","filterRowSelect":"WishesFilter_filterRowSelect__1SzBW"};